
import { _sortedSelectedFiltesString } from '~/helpers/helper-filter';

export default {
  name: 'SelectionTire',

  data: function () {
    return {
      filters: [],
      filterSelected: {},

      isLoad: true,
    };
  },

  props: {
    categoryUrl: {
      type: String,
      default: '',
    },
    categoryCharacteristics: {
      type: Array,
      default: () => [],
    },
    buttonTitle: {
      type: String,
      default: '',
    },
  },

  components: {
    Select: () => import('~/components/forms/Select'),
    SectionCheckboxRange: () => import('~/components/filter/SectionCheckboxRange'),
  },

  mounted: async function () {
    await this.getFilters();
  },

  methods: {
    getFilters: async function () {
      const slug = (this.categoryUrl || '').split('/').pop();
      const filters = await this.$api.agent.transport.get(`/categories/${slug}/filter-data`).then((res) => res.data?.options || []).catch(() => []);

      const filtersSort = [];
      this.categoryCharacteristics.map(({ characteristic }) => {
        const filter = filters.find((b) => `char_${characteristic}` === b.id);
        if (filter) {
          filtersSort.push(filter);
        }
      });

      this.filters = filtersSort;
      this.isLoad = false;
    },

    changeFilterSelected: function (filter, variant) {
      const filterSlug = filter?.slug;
      const variantSlug = variant?.slug;

      const filterSelected = { ...this.filterSelected };
      filterSelected[filter.slug] = variant.slug;

      // При выборе "Тип шины" добавляем фильтр сезон зима
      if (filterSlug === 'spikes') {
        filterSelected.season = 'zima';
      }

      // При выборе "Грязевая" добавляем фильтр сезон Грязевая
      if (filterSlug === 'gryazevaya') {
        filterSelected.season = 'leto';
      }

      if (filterSlug === 'season') {
        delete filterSelected.spikes;
        delete filterSelected.gryazevaya;
      }

      this.filterSelected = filterSelected;
    },
    changeFilterRange: function (filterSelected) {
      this.filterSelected = filterSelected;
    },

    toCatalog: function () {
      let filter = [];
      Object.keys(this.filterSelected || {}).map((key) => {
        const filterInfo = this.filters.find((t) => t.slug === key) || {};
        const filterTemplate = filterInfo?.filter_template || '';

        let value = this.filterSelected?.[key];
        if (typeof value === 'object') {
          value = Object.keys(value)?.[0];
        }
        if (filterTemplate === 'checkbox_list_with_range' || filterTemplate === 'two_selects_range') {
          const valueCurrent = (filterInfo?.variants || []).find((t) => t.slug === value)?.label;
          const maxValue = Math.max(...(filterInfo?.variants || []).map((t) => Number.parseFloat(t.label)));
          value = `${valueCurrent}:${maxValue}`;
        }

        filter.push(`${key}=${value}`);
      });
      filter = filter.join('/');
      const strings = _sortedSelectedFiltesString(filter);
      this.$router.push(`${this.categoryUrl}/f/${strings}`);
    },

    _visibleFilter: function (filter) {
      // При сезоне лето скрывать тип шин
      if (this.filterSelected?.season === 'leto' && this.filterSelected?.season !== 'zima' && filter?.slug === 'spikes') {
        return false;
      }

      // При сезоне зима скрывать Грязевая
      if (this.filterSelected?.season === 'zima' && this.filterSelected?.season !== 'leto' && filter?.slug === 'gryazevaya') {
        return false;
      }

      return true;
    },
  },
};
